export function initBannerHeroSprites() {
  document.querySelectorAll('.banner-hero__sprite-host').forEach((host) => {
    const { spriteUrl, spriteClass } = host.dataset;
    if (!spriteUrl) return;

    const startPreload = () => {
      const img = new Image();
      img.decoding = 'async';

      img.onload = () => {
        const sprite = document.createElement('div');
        sprite.className = spriteClass;
        sprite.style.backgroundImage = `url("${spriteUrl}")`;
        host.replaceWith(sprite);
      };

      img.onerror = () => {
        // opzionale: lascia il poster se lo sprite fallisce
      };

      img.src = spriteUrl;
    };

    // Dopo il first paint, per non competere con LCP
    if ('requestIdleCallback' in window) {
      requestIdleCallback(startPreload, { timeout: 2000 });
    } else {
      window.addEventListener('load', startPreload, { once: true });
    }
  });
}